import React, { Suspense } from "react";
import { HelmetProvider } from "react-helmet-async";
import Container from "react-bootstrap/Container";
import { RouterProvider } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { QueryClientProvider } from "@tanstack/react-query";
import { Provider as JotaiProvider } from "jotai";
import { CoinflowEnvs, CoinflowPurchaseProtection } from "@coinflowlabs/react";

import "./App.scss";
import router from "./router";
import { PwaContextProvider } from "./context/pwa-context";
import { queryClient } from "./react-query/query-client";
import LoadingOverlay from "./components/LoadingOverlay/LoadingOverlay";
import { initializePostHog } from "./config/posthog";
import { initializeEngage } from "./utils/engage";
import { prefetchExchangeRates } from "./react-query/queries/use-exchange-rates";
import { initializeSingular } from "./config/singular";

const COINFLOW_ENV = process.env.REACT_APP_COINFLOW_ENV as CoinflowEnvs;
const COINFLOW_MERCHANT_ID = process.env.REACT_APP_COINFLOW_MERCHANT_ID ?? "";
const ENGAGE_PUBLIC_KEY = process.env.REACT_APP_ENGAGE_PUBLIC_KEY as string;

initializeEngage(ENGAGE_PUBLIC_KEY);
initializePostHog();
initializeSingular();
prefetchExchangeRates();

function App() {
  return (
    <HelmetProvider>
      <PwaContextProvider>
        <QueryClientProvider client={queryClient}>
          <JotaiProvider>
            <Container fluid as="main" className="App p-0">
              <Suspense fallback={<LoadingOverlay />}>
                <RouterProvider router={router} />
              </Suspense>
              <Toaster toastOptions={{ duration: 3000 }} />
              <CoinflowPurchaseProtection
                merchantId={COINFLOW_MERCHANT_ID}
                coinflowEnv={COINFLOW_ENV}
              />
            </Container>
          </JotaiProvider>
        </QueryClientProvider>
      </PwaContextProvider>
    </HelmetProvider>
  );
}

export default App;
